import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product datasheets.
 * This component listens for variant update events and updates the datasheets display accordingly.
 * It handles datasheets updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductDatasheets extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateDatasheets);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateDatasheets);
  }

  /**
   * Updates the datasheets.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDatasheets = (event) => {

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    const newDatasheets = event.detail.data.html.querySelector('product-datasheets [ref="datasheetsSpan"]');
    const currentDatasheets = this.querySelector('[ref="datasheetsSpan"]');

    console.log("new Datasheets:")
    console.log(newDatasheets);

    if (!newDatasheets || !currentDatasheets) return;

    if (currentDatasheets.innerHTML !== newDatasheets.innerHTML) {
      currentDatasheets.replaceWith(newDatasheets);
    }
  };
}

if (!customElements.get('product-datasheets')) {
  customElements.define('product-datasheets', ProductDatasheets);
}
